import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import {
  fetchUsersRoutine,
  changeUserStatusRoutine,
  changeUserRoleRoutine,
  changeUserTeamRoutine,
  changeUsersTeamRoutine,
  changeUsersRoleRoutine,
  createUserRoutine,
  resendInviteRoutine,
  changeUsersStatusRoutine
} from '../../routines';
import {
  getUsers,
  changeUsersStatus,
  changeUsersRole,
  changeUsersTeam,
  createUser,
  checkUserEmail, resendInvite
} from '../../../../services/userService';
import { successToast, errorToast } from '../../../../common/helpers/toastrHelper';

function* getUsersRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getUsers, payload);
    const data = {
      ...response,
      reset: !payload.from
    };
    yield put(fetchUsersRoutine.success(data));
  } catch (error) {
    yield put(fetchUsersRoutine.failure(error.message));
  }
}

function* watchGetUsersRequest() {
  yield takeEvery(fetchUsersRoutine.TRIGGER, getUsersRequest);
}

function* changeUserStatusReq({ payload }: Routine<any>) {
  try {
    yield call(changeUsersStatus, { userIds: [payload.id], isActive: payload.isActive });
    yield put(changeUserStatusRoutine.success(payload));
    const toastText = payload.isActive ? 'reactivated' : 'deactivated';
    yield call(successToast, `User ${toastText}`, `usersPane.${toastText}`);
  } catch (error) {
    yield put(changeUserStatusRoutine.failure(error.message));
  }
}

function* watchChangeUserStatusReq() {
  yield takeEvery(changeUserStatusRoutine.TRIGGER, changeUserStatusReq);
}

function* changeUserRoleReq({ payload }: Routine<any>) {
  try {
    yield call(changeUsersRole, { userIds: [payload.id], role: payload.role });
    yield put(changeUserRoleRoutine.success(payload));
  } catch (error) {
    yield put(changeUserRoleRoutine.failure(error.message));
  }
}

function* watchChangeUserRoleReq() {
  yield takeEvery(changeUserRoleRoutine.TRIGGER, changeUserRoleReq);
}

function* changeUserTeamReq({ payload }: Routine<any>) {
  try {
    yield call(changeUsersTeam, { userIds: [payload.id], teamId: payload.team.id });
    yield put(changeUserTeamRoutine.success(payload));
  } catch (error) {
    yield put(changeUserTeamRoutine.failure(error.message));
  }
}

function* watchChangeUserTeamReq() {
  yield takeEvery(changeUserTeamRoutine.TRIGGER, changeUserTeamReq);
}

function* changeUsersTeamReq({ payload }: Routine<any>) {
  try {
    yield call(changeUsersTeam, payload);
    yield put(changeUsersTeamRoutine.success());
  } catch (error) {
    yield put(changeUsersTeamRoutine.failure(error.message));
  }
}

function* watchChangeUsersTeamReq() {
  yield takeEvery(changeUsersTeamRoutine.TRIGGER, changeUsersTeamReq);
}

function* changeUsersRoleReq({ payload }: Routine<any>) {
  try {
    yield call(changeUsersRole, payload);
    yield put(changeUsersRoleRoutine.success());
  } catch (error) {
    yield put(changeUsersRoleRoutine.failure(error.message));
  }
}

function* watchChangeUsersRoleReq() {
  yield takeEvery(changeUsersRoleRoutine.TRIGGER, changeUsersRoleReq);
}

function* changeUsersStatusReq({ payload }: Routine<any>) {
  try {
    yield call(changeUsersStatus, payload);
    yield put(changeUsersStatusRoutine.success());
  } catch (error) {
    yield put(changeUsersStatusRoutine.failure(error.message));
  }
}

function* watchChangeUsersStatusReq() {
  yield takeEvery(changeUsersStatusRoutine.TRIGGER, changeUsersStatusReq);
}

function* resendInviteReq({ payload }: Routine<any>) {
  try {
    yield call(resendInvite, { email: payload });
    yield put(resendInviteRoutine.success());
    yield call(
      successToast,
      'Invite resent to user\'s email. Remember to check spam folders!',
      'toast.resendInviteSuccess'
    );
  } catch (error) {
    yield put(resendInviteRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchresendInviteReq() {
  yield takeEvery(resendInviteRoutine.TRIGGER, resendInviteReq);
}

function* createUserReq({ payload }: Routine<any>) {
  try {
    const { isEmailUsed } = yield call(checkUserEmail, { email: payload.email });

    if (isEmailUsed) {
      yield put(createUserRoutine.failure({
        intlId: 'emailIsUsed',
        message: 'Email is already in use',
        isEmailUsed
      }));
    } else {
      yield call(createUser, payload);
      yield put(createUserRoutine.success());
      yield call(successToast, 'Invite emails sent! Remember to check spam filters', 'toast.addNewUserSuccess');
    }
  } catch (error) {
    yield put(createUserRoutine.failure({ errorIntlId: error.message }));
    yield call(errorToast, error.message);
  }
}

function* watchCreateUserReq() {
  yield takeEvery(createUserRoutine.TRIGGER, createUserReq);
}

export default function* usersAndTeamsSaga() {
  yield all([
    watchGetUsersRequest(),
    watchChangeUserRoleReq(),
    watchChangeUserStatusReq(),
    watchChangeUserTeamReq(),
    watchChangeUsersTeamReq(),
    watchChangeUsersRoleReq(),
    watchChangeUsersStatusReq(),
    watchCreateUserReq(),
    watchresendInviteReq()
  ]);
}
